import { useMemo } from "react";

import { isMenuContentElement } from "~/modules/typo3/schema";
import type * as typo3 from "~/modules/typo3/schema";
import { useMainNavigationData } from "~/hooks/useMainNavigationData";

const SOCIAL_MEDIA_NAV_COL_POS: number = 1101;

export default function FooterSocial() {
	const allCes =
		useMainNavigationData()?.[`colPos${SOCIAL_MEDIA_NAV_COL_POS}`];

	const socialLinkItems = useMemo(
		() =>
			allCes
				?.filter(isMenuContentElement)
				.flatMap((menuCe) => menuCe.content.menu) ?? [],
		[allCes],
	);

	return (
		<ul
			className={`social footer-item element count-${socialLinkItems.length}`}
		>
			{socialLinkItems.map(
				(item: typo3.NavigationItem, index: number) => {
					const thumbnail = item.thumbnail?.[0];

					return (
						<li key={index}>
							<Social
								label={item.title}
								href={item.link}
								imgUrl={
									thumbnail?.publicUrl ??
									"/img/gradient-24.jpg"
								}
								// handle empty target as no target
								linkTarget={item.target || undefined}
							/>
						</li>
					);
				},
			)}
		</ul>
	);
}

type SocialEntry = {
	label: string;
	imgUrl: string;
	href: string;
	linkTarget: string | undefined;
};

function Social({ label, href, imgUrl, linkTarget }: SocialEntry) {
	return (
		<div className="social-media-item">
			<a
				href={href}
				target={linkTarget}
				rel="noreferrer"
				className="inner"
			>
				<div className="social-media-item-image">
					<img
						className="mb-[0.2rem] w-[1.25rem] self-center rounded-full object-cover object-center transition-transform group-hover/social:scale-[1.05]"
						loading="lazy"
						src={imgUrl}
						alt=""
					/>
				</div>
				<div className="social-media-item-label">{label}</div>
			</a>
		</div>
	);
}
